import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const EmployeesIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الموظفين",
				breadcrumb: "الموظفين",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة موظف جديد",
					link: "/employees/create",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/employees/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data[0].categories[0].posts);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				{data.map(item =>
					item.data.employees.map(employee => (
						<div className="col-md-3" key={employee.name}>
							<div className="employees">
								{checkPermissions(["post-delete"]) && (
									<button
										onClick={() => handleDelete(item.id)}
										aria-label="حذف"
									>
										<i className="fas fa-trash"></i>
									</button>
								)}
								<Link
									to={
										checkPermissions(["post-edit"])
											? `/employees/show/${item.id}`
											: "/"
									}
								>
									<img
										src={`${process.env.REACT_APP_MAIN_URL}${employee.image}`}
										alt={employee.name}
									/>
									<h4>{employee.name}</h4>
								</Link>
							</div>
						</div>
					))
				)}
			</div>
		</section>
	);
};

export default EmployeesIndex;
